"use client";

import { c as _c } from "react/compiler-runtime";
import MemesWaveQuickVoteTrigger from "@/components/brain/left-sidebar/waves/MemesWaveQuickVoteTrigger";
import MemesWaveZapIcon from "@/components/brain/left-sidebar/waves/MemesWaveZapIcon";
import { useMemesWaveFooterStats } from "@/hooks/useMemesWaveFooterStats";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import { AnimatePresence, motion } from "framer-motion";
import React from "react";
interface MemesWaveFooterProps {
  readonly collapsed?: boolean | undefined;
  readonly onOpenQuickVote: () => void;
  readonly onPrefetchQuickVote?: (() => void) | undefined;
}
const revealTransition = {
  duration: 0.22,
  ease: "easeOut"
} as const;
const MemesWaveFooter: React.FC<MemesWaveFooterProps> = t0 => {
  const $ = _c(16);
  const {
    collapsed: t1,
    onOpenQuickVote,
    onPrefetchQuickVote
  } = t0;
  const collapsed = t1 === undefined ? false : t1;
  const {
    isReady,
    uncastPower,
    unratedCount,
    votingLabel
  } = useMemesWaveFooterStats();
  let t2;
  if ($[0] !== onOpenQuickVote || $[1] !== unratedCount) {
    t2 = () => {
      if (unratedCount <= 0) {
        return;
      }
      onOpenQuickVote();
    };
    $[0] = onOpenQuickVote;
    $[1] = unratedCount;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleOpenQuickVote = t2;
  let t3;
  if ($[3] !== onPrefetchQuickVote || $[4] !== unratedCount) {
    t3 = () => {
      if (unratedCount <= 0) {
        return;
      }
      onPrefetchQuickVote?.();
    };
    $[3] = onPrefetchQuickVote;
    $[4] = unratedCount;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handlePrefetchQuickVote = t3;
  let t4;
  if ($[6] !== collapsed || $[7] !== handleOpenQuickVote || $[8] !== handlePrefetchQuickVote || $[9] !== isReady || $[10] !== uncastPower || $[11] !== unratedCount || $[12] !== votingLabel) {
    t4 = isReady && typeof uncastPower === "number" && <motion.div initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 16
    }} transition={revealTransition} className={collapsed ? "tw-z-10 tw-flex tw-flex-shrink-0 tw-justify-center tw-px-2 tw-pb-2 tw-pt-1" : "tw-relative tw-z-20 tw-mt-auto tw-flex-shrink-0"}>{collapsed ? <MemesWaveQuickVoteTrigger onOpenQuickVote={handleOpenQuickVote} onPrefetchQuickVote={handlePrefetchQuickVote} unratedCount={unratedCount} /> : <button type="button" aria-label={`Uncast Power, ${formatNumberWithCommas(uncastPower)} ${votingLabel ?? "Votes"} left, ${formatNumberWithCommas(unratedCount)} unexplored`} onClick={handleOpenQuickVote} onFocus={handlePrefetchQuickVote} onMouseEnter={handlePrefetchQuickVote} className="tw-group tw-mt-auto tw-w-full tw-flex-shrink-0 tw-cursor-pointer tw-border-0 tw-border-t tw-border-solid tw-border-iron-800/60 tw-bg-black tw-p-4 tw-text-left tw-transition-colors desktop-hover:hover:tw-bg-iron-900/40"><div className="tw-relative tw-flex tw-items-center tw-justify-between tw-gap-4 tw-overflow-hidden tw-rounded-xl tw-border tw-border-solid tw-border-[#2d3753] tw-bg-[#0c1018] tw-px-4 tw-py-2.5 tw-shadow-lg tw-transition-all tw-duration-200 desktop-hover:group-hover:tw-border-[#3a4670] desktop-hover:group-hover:tw-bg-[#0f1420]"><span aria-hidden="true" className="tw-pointer-events-none tw-absolute tw-inset-0 -tw-translate-x-full tw-bg-gradient-to-r tw-from-white/0 tw-via-white/[0.08] tw-to-white/0 tw-opacity-50 tw-transition-transform tw-duration-1000 tw-ease-out desktop-hover:group-hover:tw-translate-x-full" /><div className="tw-relative tw-z-10 tw-flex tw-min-w-0 tw-flex-col tw-gap-1.5"><span className="tw-text-[10px] tw-font-bold tw-uppercase tw-tracking-widest tw-text-[#6b7c93]">Uncast votes</span><div className="tw-flex tw-items-center tw-gap-2"><MemesWaveZapIcon className="tw-size-4 tw-flex-shrink-0 tw-fill-primary-400/20 tw-text-primary-400" /><span className="tw-truncate tw-text-sm tw-font-semibold tw-tracking-tight tw-text-white">{formatNumberWithCommas(uncastPower)}{votingLabel ? ` ${votingLabel}` : " votes"}</span></div></div><span className="tw-relative tw-z-10 tw-text-xs tw-font-semibold tw-text-[#8199ea] tw-shadow-sm">{formatNumberWithCommas(unratedCount)} unexplored</span></div></button>}</motion.div>;
    $[6] = collapsed;
    $[7] = handleOpenQuickVote;
    $[8] = handlePrefetchQuickVote;
    $[9] = isReady;
    $[10] = uncastPower;
    $[11] = unratedCount;
    $[12] = votingLabel;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t4) {
    t5 = <AnimatePresence>{t4}</AnimatePresence>;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};
export default MemesWaveFooter;